import { FeatureItem, ItemDetailsSelector } from '../utils';
import { useSelector } from 'react-redux';

type UseItemDetailsItem = FeatureItem | null | undefined;

export const useItemDetails = <T extends UseItemDetailsItem>(
	item: T,
	getItemDetailsSelector?: ItemDetailsSelector,
): T => {
	const extraDetails = useSelector(state =>
		getItemDetailsSelector?.(state, item?.id ?? null),
	);

	if (extraDetails) {
		return { ...item, ...extraDetails } as T;
	}
	return item;
};
